import PropTypes from 'prop-types';
import { ConfigProvider, theme } from 'antd';

const { defaultAlgorithm } = theme;

export default function ThemeCustomization({ children }) {
  return (
    <ConfigProvider
      componentSize="large"
      theme={{
        algorithm: defaultAlgorithm,
        token: {
          buttonSize: 'medium',
          // colorPrimary: '#000000',
          colorPrimary: '#81C21E',
          colorSuccess: '#4caf50',
          colorWarning: '#ff9800',
          colorError: '#f44336',
          colorInfo: '#2196f3',
          borderRadius: 8,
          fontFamily: "'Public Sans', sans-serif",
        },
        components: {
          Layout: {
            siderBg: '#000000',
            triggerBg: '#000000',
          },

          Menu: {
            darkItemBg: '#000000',
            darkSubMenuItemBg: '#111111',
            darkItemSelectedBg: '#81C21E',
            darkItemHoverBg: '#1f1f1f',
            darkPopupBg: '#000000',
          },
        },


      }}
    >
      {children}
    </ConfigProvider>
  );
}

ThemeCustomization.propTypes = { children: PropTypes.node };
